import { Phone } from "lucide-react";
import { FaLinkedinIn } from "react-icons/fa";
import { LEADERS } from "@/data/content";
import { SectionLabel } from "@/components/SectionLabel";
import { AccentHeading } from "@/components/AccentHeading";
import { Reveal } from "@/components/Reveal";

export const Team = () => {
  const leader = LEADERS[0];
  return (
    <section data-testid="leadership" className="bg-[var(--bg-primary)] py-16 md:py-24 lg:py-28">
      <div className="container-pad">
        <div className="text-center">
          <Reveal className="flex justify-center"><SectionLabel>OUR LEADERSHIP</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <AccentHeading as="h2" text="The Visionary Behind *Godavari*" className="mt-4 block text-4xl leading-[1.05] md:text-5xl" />
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div
            data-testid="leader-card-1"
            className="glass-card mx-auto mt-12 w-full max-w-4xl rounded-[28px] p-7 transition-[border-color,box-shadow] duration-300 hover:border-[var(--border-hover)] hover:shadow-[var(--shadow-md),var(--shadow-warm)] md:p-10"
          >
            <div className="flex flex-col items-center gap-8 text-center md:flex-row md:items-center md:gap-10 md:text-left">
              <div className="flex flex-col items-center gap-4 md:w-1/3 md:border-r md:border-[var(--border-subtle)] md:pr-10">
                {leader.photo ? (
                  <div className="relative h-28 w-28 shrink-0 sm:h-32 sm:w-32">
                    <span className="absolute -inset-1 rounded-full bg-[image:var(--gradient-cta)] opacity-70 blur-[2px]" aria-hidden="true" />
                    <img
                      src={leader.photo}
                      alt={`${leader.name}, ${leader.role}`}
                      loading="lazy"
                      className="relative h-full w-full rounded-full object-cover object-top shadow-[var(--shadow-warm)] ring-2 ring-[var(--accent-secondary)]/60"
                    />
                  </div>
                ) : (
                  <span className="grid h-24 w-24 shrink-0 place-items-center rounded-full bg-[image:var(--gradient-cta)] font-playfair text-3xl font-bold text-[#0C0C0C] shadow-[var(--shadow-warm)]">
                    {leader.initials}
                  </span>
                )}
                <div>
                  <h3 className="font-playfair text-2xl text-[var(--text-primary)]">{leader.name}</h3>
                  <div className="mt-1 font-inter text-sm italic text-[var(--accent-secondary)]">{leader.role}</div>
                </div>
              </div>
              <div className="md:flex-1">
                <p className="leading-relaxed text-[var(--text-secondary)]">{leader.bio}</p>
                {(leader.tel || leader.linkedin) && (
                  <div className="mt-6 flex flex-wrap items-center justify-center gap-3 md:justify-start">
                    {leader.tel && (
                      <a
                        href={`tel:${leader.tel}`}
                        aria-label={`Call ${leader.name}`}
                        className="inline-flex items-center gap-2 rounded-full border border-[var(--border-subtle)] px-4 py-2 text-sm text-[var(--text-secondary)] transition-colors hover:border-[var(--border-hover)] hover:text-[var(--accent-secondary)]"
                      >
                        <Phone size={15} /> {leader.phone}
                      </a>
                    )}
                    {leader.linkedin && (
                      <a
                        href={leader.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`${leader.name} on LinkedIn`}
                        className="grid h-10 w-10 place-items-center rounded-full border border-[var(--border-subtle)] text-[var(--text-secondary)] transition-colors hover:border-[var(--border-hover)] hover:text-[var(--accent-secondary)]"
                      >
                        <FaLinkedinIn size={15} />
                      </a>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
